import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import AppRoute from './Components/AppRoute';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import { Provider } from 'react-redux';
import store from './Store/store';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Header />
        <AppRoute />
        <Footer />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
